let config = {};
if (process.env.NODE_ENV === "development") {
  config = {
    baseURL: `http://qa.app.izenda.com/api`,
    timeout: 100000,
    convenienceFee: 3,
    publisher_key: "pk_test_odC7dJawae62Y6Z27QJHT62f",
    public_key: "8cb2b9d78aa5673b1ee12e03039a84",
    env: "sandbox",
    gtmId: "GTM-K726PT4",
    FIPSEnabled: false
  };
} else {
  config = {
    baseURL: `http://application.izenda.com/api`,
    timeout: 100000,
    convenienceFee: 3,
    publisher_key: "pk_live_a7moVvF2j8vfGuNopOlXkx0l",
    public_key: "8cb2b9d78aa5673b1ee12e03039a84",
    env: "development",
    gtmId: "GTM-W7VJ5V7",
    FIPSEnabled: false
  };
}

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js